export default {}

export const TOKEN_APP = '2U1mMYl9t0msQ7lGKgXRpdpmp6bzaSV02WLA47uA43La'

export const BASE_URL = 'https://api.myvopsa.com'
export const API_URL = BASE_URL + '/'
export const API_UPLOADS = BASE_URL
export const INTRANET_URL = 'https://www.myvopsa.com'



// WEBPACK FOOTER //
// ./src/common/config.js